import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'

export const AgreementInfo = styled(({ children, fontWeight, ...props }) => <span {...props}>{children}</span>)`
  font-size: 16px;
  font-weight: ${props => props.fontWeight};
  line-height: 20px;
  margin: 0 5px;
  padding: 0;
`

export const AgreementWrapper = styled('div')`
  display: inline-block;
  margin: 0 0 20px 0;
`

export const Grid = styled(BaseGrid)`
  &.MuiGrid-root {
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0'};
  }
`

export const Input = styled('input')`
  animation-duration: 10ms;
  animation-name: mui-auto-fill-cancel;
  background: none;
  border: 0;
  border-bottom: 1px solid ${props => (props.error ? props.theme.palette.brand.error : props.theme.palette.brand.gray1)};
  box-sizing: border-box;
  color: currentColor;
  display: inline-flex;
  flex-grow: 1;
  font: inherit;
  font-weight: bold;
  height: 100%;
  letter-spacing: inherit;
  margin: 5px 5px 0;
  min-width: 400px;
  overflow: hidden;
  padding: 0 0.75rem 0.1rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;

  &:focus {
    outline: 0;
  }
`

export const Strong = styled('b')`
  font-weight: 700;
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin || 'initial'};
    max-width: ${props => props.maxWidth || 'initial'};
    padding: ${props => props.padding || '0'};
    text-align: left;
  }

  &.MuiGrid-item {
    margin: ${props => props.margin || 'initial'};
  }
`

export const Underline = styled('u')`
  text-decoration-line: underline;
`

export const ScrollableCard = styled('div')`
  max-height: 300px;
  overflow-y: auto;
  padding: 20px;
  border: 1px solid ${props => props.theme.palette.brand.gray2};
  border-radius: 8px;
  text-align: justify;
  background-color: ${props => props.theme.palette.blank};
  ${props => props.theme.breakpoints.up('lg')} {
    max-height: 400px;
  }
`

export const SectionInputContainer = styled('span')`
  display: inline-block;
  height: 0;
  margin-left: 5px;
  margin-right: 5px;
  width: auto;
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;

  && .MuiInputBase-root {
    background: transparent;
    border: none;
    border-bottom: 2px solid ${props => props.theme.palette.custom.iconGray};
    border-radius: 0;
    box-shadow: none;
    display: inline-block;
    height: 20px;
    margin: 0;
    outline: none;
    padding: 0;
    vertical-align: middle;

    &:focus-within {
      border-bottom: 2px solid ${props => props.theme.palette.custom.iconGray};
      box-shadow: none;
      outline: none;
    }
  }

  && .MuiInputBase-input {
    background: transparent;
    border: none;
    box-shadow: none;
    margin: 0;
    outline: none;
    padding: 0;
    width: 300px;

    &:focus {
      border: none;
      outline: none;
    }
  }
`

export const SectionInputNameContainer = styled('span')`
  display: inline-block;
  height: 0;
  margin-left: 5px;
  margin-right: 5px;
  width: auto;
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;

  && .MuiInputBase-root {
    background: transparent;
    border: none;
    border-bottom: 2px solid ${props => props.theme.palette.custom.iconGray};
    border-radius: 0;
    box-shadow: none;
    display: inline-block;
    height: 20px;
    margin: 0;
    outline: none;
    padding: 0;
    vertical-align: middle;

    &:focus-within {
      border-bottom: 2px solid ${props => props.theme.palette.custom.iconGray};
      box-shadow: none;
      outline: none;
    }
  }

  && .MuiInputBase-input {
    background: transparent;
    border: none;
    box-shadow: none;
    margin: 0;
    outline: none;
    padding: 0;
    width: 200px;

    &:focus {
      border: none;
      outline: none;
    }
  }
`
